// Location constants
export const LOCATION_LIST_REQUEST = 'LOCATION_LIST_REQUEST';
export const LOCATION_LIST_SUCCESS = 'LOCATION_LIST_SUCCESS';
export const LOCATION_LIST_FAIL = 'LOCATION_LIST_FAIL';

export const LOCATION_DETAILS_REQUEST = 'LOCATION_DETAILS_REQUEST';
export const LOCATION_DETAILS_SUCCESS = 'LOCATION_DETAILS_SUCCESS';
export const LOCATION_DETAILS_FAIL = 'LOCATION_DETAILS_FAIL';

export const LOCATION_CREATE_REQUEST = 'LOCATION_CREATE_REQUEST';
export const LOCATION_CREATE_SUCCESS = 'LOCATION_CREATE_SUCCESS';
export const LOCATION_CREATE_FAIL = 'LOCATION_CREATE_FAIL';
export const LOCATION_CREATE_RESET = 'LOCATION_CREATE_RESET';

export const LOCATION_UPDATE_REQUEST = 'LOCATION_UPDATE_REQUEST';
export const LOCATION_UPDATE_SUCCESS = 'LOCATION_UPDATE_SUCCESS';
export const LOCATION_UPDATE_FAIL = 'LOCATION_UPDATE_FAIL';
export const LOCATION_UPDATE_RESET = 'LOCATION_UPDATE_RESET';

export const LOCATION_DELETE_REQUEST = 'LOCATION_DELETE_REQUEST';
export const LOCATION_DELETE_SUCCESS = 'LOCATION_DELETE_SUCCESS';
export const LOCATION_DELETE_FAIL = 'LOCATION_DELETE_FAIL';
export const LOCATION_DELETE_RESET = 'LOCATION_DELETE_RESET';

// Venue constants
export const VENUE_LIST_REQUEST = 'VENUE_LIST_REQUEST';
export const VENUE_LIST_SUCCESS = 'VENUE_LIST_SUCCESS';
export const VENUE_LIST_FAIL = 'VENUE_LIST_FAIL';

export const VENUE_CREATE_REQUEST = 'VENUE_CREATE_REQUEST';
export const VENUE_CREATE_SUCCESS = 'VENUE_CREATE_SUCCESS';
export const VENUE_CREATE_FAIL = 'VENUE_CREATE_FAIL';
export const VENUE_CREATE_RESET = 'VENUE_CREATE_RESET';

export const VENUE_ADD_CLUB_REQUEST = 'VENUE_ADD_CLUB_REQUEST';
export const VENUE_ADD_CLUB_SUCCESS = 'VENUE_ADD_CLUB_SUCCESS';
export const VENUE_ADD_CLUB_FAIL = 'VENUE_ADD_CLUB_FAIL';
export const VENUE_ADD_CLUB_RESET = 'VENUE_ADD_CLUB_RESET';

// Club constants
export const CLUB_LIST_REQUEST = 'CLUB_LIST_REQUEST';
export const CLUB_LIST_SUCCESS = 'CLUB_LIST_SUCCESS';
export const CLUB_LIST_FAIL = 'CLUB_LIST_FAIL';

export const CLUB_DETAILS_REQUEST = 'CLUB_DETAILS_REQUEST';
export const CLUB_DETAILS_SUCCESS = 'CLUB_DETAILS_SUCCESS';
export const CLUB_DETAILS_FAIL = 'CLUB_DETAILS_FAIL';

export const CLUB_CREATE_REQUEST = 'CLUB_CREATE_REQUEST';
export const CLUB_CREATE_SUCCESS = 'CLUB_CREATE_SUCCESS';
export const CLUB_CREATE_FAIL = 'CLUB_CREATE_FAIL';
export const CLUB_CREATE_RESET = 'CLUB_CREATE_RESET';

export const CLUB_UPDATE_REQUEST = 'CLUB_UPDATE_REQUEST';
export const CLUB_UPDATE_SUCCESS = 'CLUB_UPDATE_SUCCESS';
export const CLUB_UPDATE_FAIL = 'CLUB_UPDATE_FAIL';
export const CLUB_UPDATE_RESET = 'CLUB_UPDATE_RESET';

export const CLUB_DELETE_REQUEST = 'CLUB_DELETE_REQUEST';
export const CLUB_DELETE_SUCCESS = 'CLUB_DELETE_SUCCESS';
export const CLUB_DELETE_FAIL = 'CLUB_DELETE_FAIL';
export const CLUB_DELETE_RESET = 'CLUB_DELETE_RESET';

export const CLUB_STATS_REQUEST = 'CLUB_STATS_REQUEST';
export const CLUB_STATS_SUCCESS = 'CLUB_STATS_SUCCESS';
export const CLUB_STATS_FAIL = 'CLUB_STATS_FAIL';

export const CLUB_ASSIGN_ADMIN_REQUEST = 'CLUB_ASSIGN_ADMIN_REQUEST';
export const CLUB_ASSIGN_ADMIN_SUCCESS = 'CLUB_ASSIGN_ADMIN_SUCCESS';
export const CLUB_ASSIGN_ADMIN_FAIL = 'CLUB_ASSIGN_ADMIN_FAIL';

// Selected club (for filtering)
export const SET_SELECTED_CLUB = 'SET_SELECTED_CLUB';
export const CLEAR_SELECTED_CLUB = 'CLEAR_SELECTED_CLUB';

// Chip Inventory constants
export const CHIP_INVENTORY_REQUEST = 'CHIP_INVENTORY_REQUEST';
export const CHIP_INVENTORY_SUCCESS = 'CHIP_INVENTORY_SUCCESS';
export const CHIP_INVENTORY_FAIL = 'CHIP_INVENTORY_FAIL';
export const CHIP_INVENTORY_RESET = 'CHIP_INVENTORY_RESET';

export const CHIP_INVENTORY_SETUP_REQUEST = 'CHIP_INVENTORY_SETUP_REQUEST';
export const CHIP_INVENTORY_SETUP_SUCCESS = 'CHIP_INVENTORY_SETUP_SUCCESS';
export const CHIP_INVENTORY_SETUP_FAIL = 'CHIP_INVENTORY_SETUP_FAIL';
export const CHIP_INVENTORY_SETUP_RESET = 'CHIP_INVENTORY_SETUP_RESET';

export const CHIP_INVENTORY_ADD_REQUEST = 'CHIP_INVENTORY_ADD_REQUEST';
export const CHIP_INVENTORY_ADD_SUCCESS = 'CHIP_INVENTORY_ADD_SUCCESS';
export const CHIP_INVENTORY_ADD_FAIL = 'CHIP_INVENTORY_ADD_FAIL';
export const CHIP_INVENTORY_ADD_RESET = 'CHIP_INVENTORY_ADD_RESET';

export const CHIP_INVENTORY_REMOVE_REQUEST = 'CHIP_INVENTORY_REMOVE_REQUEST';
export const CHIP_INVENTORY_REMOVE_SUCCESS = 'CHIP_INVENTORY_REMOVE_SUCCESS';
export const CHIP_INVENTORY_REMOVE_FAIL = 'CHIP_INVENTORY_REMOVE_FAIL';
export const CHIP_INVENTORY_REMOVE_RESET = 'CHIP_INVENTORY_REMOVE_RESET';

export const CHIP_INVENTORY_HISTORY_REQUEST = 'CHIP_INVENTORY_HISTORY_REQUEST';
export const CHIP_INVENTORY_HISTORY_SUCCESS = 'CHIP_INVENTORY_HISTORY_SUCCESS';
export const CHIP_INVENTORY_HISTORY_FAIL = 'CHIP_INVENTORY_HISTORY_FAIL';

export const CHIP_INVENTORY_SUMMARY_REQUEST = 'CHIP_INVENTORY_SUMMARY_REQUEST';
export const CHIP_INVENTORY_SUMMARY_SUCCESS = 'CHIP_INVENTORY_SUMMARY_SUCCESS';
export const CHIP_INVENTORY_SUMMARY_FAIL = 'CHIP_INVENTORY_SUMMARY_FAIL';

export const CHIP_INVENTORY_RECONCILE_REQUEST = 'CHIP_INVENTORY_RECONCILE_REQUEST';
export const CHIP_INVENTORY_RECONCILE_SUCCESS = 'CHIP_INVENTORY_RECONCILE_SUCCESS';
export const CHIP_INVENTORY_RECONCILE_FAIL = 'CHIP_INVENTORY_RECONCILE_FAIL';
export const CHIP_INVENTORY_RECONCILE_RESET = 'CHIP_INVENTORY_RECONCILE_RESET';

// Staff club access (all assigned clubs deactivated)
export const CLUB_ACCESS_STATUS = 'CLUB_ACCESS_STATUS';
export const CLUB_INACTIVE_CODE = 'CLUB_INACTIVE';
